import { createFileRoute } from "@tanstack/react-router";
import { AuthScreen } from "@/components/auth/auth-screen";
export const Route = createFileRoute("/auth/sign-up")({
  component: () => <AuthScreen key="sign-up" mode="sign-up" />,
});
